<template>
<v-container style="margin: 0px; padding: 0px; max-width:100%">
    <v-toolbar color="indigo" dark dense>
      <v-toolbar-title>{{args.desc}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
          <v-btn dark  text @click.native="close">Close</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div class="compact-form"  style="margin-left: 20px;">
      <v-layout row align-center  justify="center">
      <v-radio-group v-model="mode" row>
        <v-radio label="Add New" value="new"></v-radio>
        <v-radio label="Edit Existing" value="existing"></v-radio>
      </v-radio-group>
      <v-flex xs5>
      <v-select  
        style="margin: 0px; padding-top: 25px; padding-right: 20px;" 
        dense 
        v-if="mode == 'existing'" 
        outlined 
        v-model='selectedUser' 
        :items="users" 
        label="Select User"
        item-text="fullName"
      >
      <template slot="selection" slot-scope="data">
        {{ data.item.fname }} {{ data.item.lname}}
      </template>
      <template slot="item" slot-scope="data">
        {{ data.item.fname }} {{ data.item.lname}}
      </template>
      </v-select>
      <v-select  
        style="margin: 0px; padding-top: 25px; padding-right: 20px;" 
        dense 
        v-if="mode=='new' && origLoggedinUser.role == 'super'"
        outlined 
        v-model='selectedOrg' 
        :items="orgs" 
        label="Select Org"
        item-text="fullName"
      ></v-select>
      </v-flex>
      <v-spacer />
      <v-flex xs1 >
        <v-btn color='blue' :disabled="!clientData.fname || !clientData.lname || access_error != null" @click="save">Save</v-btn>
      </v-flex>
      </v-layout>
      <div style="padding-bottom: 10px; margin-top: 2px; color: #ff0000">{{err}}</div>
      <div id="clientsPeople">
        <v-layout row>
        <v-flex xs3>
        <v-text-field dense v-model="clientData.fname" label="First Name" outlined />
        <v-text-field dense v-model="clientData.mi" label="Middle Name" outlined />
        <v-text-field dense v-model="clientData.lname" label="Last Name" outlined />
        <v-select dense v-model="clientData.state" label="State" outlined :items="usStates" item-text="name" item-value="code"></v-select>        </v-flex>
        <v-flex xs1 />
        <v-flex xs3>
        <v-select dense outlined v-model="userData.role" :items="roles" label="Role"></v-select>
        <v-text-field dense v-model="clientData.email" label="Email" outlined />
        <v-text-field dense v-model="clientData.empnum" label="Employee Number" outlined />
        <v-text-field dense v-model="clientData.badge" label="Badge Number" outlined />
        </v-flex>
        <v-flex xs1 />
        <v-flex xs3>
          Photo
        </v-flex>
        </v-layout>
      </div>
      <v-divider />
      <v-checkbox v-model="allowAccess" label="Allow Login to Entrinsia Cortex"></v-checkbox>
      <v-checkbox v-model="inactive" label="Suspend Login Access"></v-checkbox>
      <div v-if="allowAccess">
        <h4 style="padding-bottom: 2px;">Access Control </h4>
        <div style="padding-bottom: 15px; padding-top: 1px;">(select which facilities, modules and reports this user has access to)</div>
        <v-layout row>
          <v-flex xs3>
            <v-select
              dense
              outlined
              v-model="access"
              :items="['Web UI', 'Mobile App']"
              multiple
              label="Allow login to:"
              :error-messages="access_error"
              >
            </v-select>
          </v-flex>
        </v-layout>
        <p />
        <v-layout row>
        <v-flex xs3>
          <v-select 
            dense 
            outlined 
            v-model="allowedFacilities" 
            :items="facilities" 
            label="Allow access to facilities"
            item-text="fullName"
            item-value="name"
            multiple
          >
          <!-- <template slot="selection" slot-scope="data">
          </template> -->
          </v-select>
        </v-flex>
        <v-flex xs1 />
        <v-flex xs3>
          <v-select dense outlined v-model="selectedFacility" :items="allowedFacilities" label="Select Facility"></v-select>
        </v-flex>
        <v-flex xs1 />
        <v-flex xs3>
          <v-select 
            dense 
            outlined 
            v-model="allowedModules" 
            :items="modules" 
            label="Modules"
            multiple
            item-text="name"
          ></v-select>
        </v-flex>
        </v-layout>
        <!-- {{selectedEmployee}} -->
      </div>
    </div>
  </v-container>
</template>
<script>
import { sync } from "vuex-pathify"
import axiosInstances from "@/../../coreui/server/axiosInstances"
export default {
  props: ['args'],
  data: () => ({
    err: null,
    mode: 'new',
    user: {},
    users: [],
    orgs: [],
    roles: [],
    origEmail: null,
    selectedUser: null,
    selectedOrg: null,
    clientData: {},
    userData: {props:{}},
    allowAccess: false,
    inactive: false,
    allowedFacilities: [],
    facilities: [],
    selectedFacility: null,
    modules: [],
    allowedModules: null,
    usStates: [],
    access: [],
    access_error: null
  }),
  computed: {
    origLoggedinUser: sync('login/origLoggedinUser'),
    loggedinUser: sync('login/loggedinUser'),
    origLoggedinOrg: sync('login/origLoggedinOrg')
  },
  watch: {
    mode: {
      immediate: true,
      async handler (val) {
        this.clear()
        if (val == 'new') {
          this.orgs = []
          let orgs = await axiosInstances.loginServer.get('dt/v1/org?IsFacility=no')
          this.orgs = orgs.data
          console.log('orgs = ', this.orgs)
        } else {
          let curUsers = await axiosInstances.apiServer.get('/dt/v1/set_contacts_people')
          this.users = curUsers.data
        }
      }
    },
    access: {
      immediate: true,
      handler (val) {
        console.log(val)
        this.access_error = val.length == 0 ? 'Select at least one' : null
      }

    },
    clientData: {
      deep: true,
      handler (val) {
        this.err = null
      }
    },
    selectedFacility: {
      handler(val) {
        console.log(val)
        try {
          // console.log(this.userData)
          let fac = this.userData.props.modules.filter(obj => {return Object.keys(obj)[0] === val})
          console.log('fac=', fac)
          this.allowedModules = fac[0][val]
          // console.log(this.origLoggedinUser)
        } catch {
          this.allowedModules = []
        }
        // console.log(this.origLoggedinUser.props)
        // this.modules = this.origLoggedinUser.props.modules[val]
      }
    },
    allowedModules: {
      handler(val) {
        console.log(this.selectedFacility, this.userData.props)
        let index = -1
        if (this.userData.props && this.userData.props.modules) {
          index = this.userData.props.modules.findIndex((i) => Object.keys(i)[0] == this.selectedFacility)
        } else {
          this.userData.props = {}
          this.userData.props.modules = []
        }
        console.log('index = ', index)
        let newVal = {}
        newVal[this.selectedFacility] = this.allowedModules
        console.log(newVal)
        if (index == -1) {
          this.userData.props.modules.push(newVal)
        } else {
          this.userData.props.modules[index] = newVal
        }
        console.log(this.userData)
      }
    },
    selectedUser: {
      async handler (val) {
        if (val == null || val.email == null) return
        this.origEmail = val.email
        console.log(val)
        this.access= this.origLoggedinUser['access']
        this.clientData = Object.assign({}, val)
        if (val.uid) {
          let res = await axiosInstances.loginServer.get('/dt/v1/users?email='+val.email)
          if (res == null || res.data == null || res.data.length != 1) {
            console.log("invalid user ", val.email, res)
            return
          } 
          let userData = res.data[0]
          console.log('user data: ', userData)
          this.userData = userData
          this.allowAccess = true
          if (this.userData.active == 'no') {
            this.inactive = true
          } else {
            this.inactive = false
          }
          this.allowedFacilities = userData.props.modules.map(i => Object.keys(i)[0])
          this.access = userData.access
        }
      }
    }
  },
  methods: {
    close() {
      this.$router.go(-1)
    },
    async save () {
      if (this.mode == 'new') {
        let check = await axiosInstances.loginServer.get('dt/v1/users?email='+this.clientData.email)
        if (check != null && check.data != null) {
          this.err = this.clientData.email + " : email already exists"
          return
        }
      } else {
        delete this.userData['password']
        let payload = {}
        payload.origEmail = this.origEmail
        payload.clientData = this.clientData
        payload.userData = this.strip(this.userData)
        payload.access = this.access
        payload.allowAccess = this.allowAccess ? 'yes' : 'no'
        payload.action = this.mode == 'new' ? 'customer_user_create' : 'customer_user_update'
        console.log('payload: ', payload)
        await axiosInstances.origApiServer.post('/dt/v1/temp_user_manage', payload)
        console.log(payload)
      }
      this.clear()
      this.mode = 'new'
    },
    clear() {
      this.selectedUser = null
      this.user = {}
      this.clientData = {}
      this.userData = {}
      this.tempData = {}
      this.access = false
      this.allowAccess = false
    },
    strip (i) {
      let ni = {}
      ni.props = i.props
      ni.active = this.inactive ? 'no' : 'yes'
      return ni
    }
  },
  async mounted () {
    let states = await axiosInstances.loginServer.get('/dt/v1/set_usstate')
    if (states != null && states.data != null) {
      this.usStates = states.data
    }
    this.roles = ['admin', 'user']
    if (this.origLoggedinUser.role == 'super') {
      this.roles.unshift('super')
    }
    let res = await axiosInstances.loginServer.get('/dt/v1/sup_modules')
    this.modules = res.data
    res = await axiosInstances.loginServer.get('/dt/v1/org?return=fullName&return=name&master=' + this.loggedinUser.org)
    console.log('Fs: ', res)
    res = res == null || res.data == null ? [] : res.data
    this.facilities = res
  }
}
</script>
<style scoped>
.compact-form {
    transform: scale(0.95);
    transform-origin: left;
}
</style>